import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { UploadFilesService } from '../_services/upload-files.service';
import { AppAnalysisService } from '../_services/app-analysis.service';

@Component({
  selector: 'lib-upload-file-lib',
  templateUrl: './upload-file-lib.component.html',
  styleUrls: ['./upload-file-lib.component.css']
})

export class UploadFileLibComponent implements OnInit {
  isNewMapCreated = false;
  // Go to next stepper in upload Vector Csv module
  @Input() splitPoly
  @Input() mergePoly
  @Input() Geocoder
  @Input() isStoreMapper
  @Output() nextStepper = new EventEmitter<any>();
  @Output() emitData = new EventEmitter<any>();
  @Output() deletePointForSplitPolygon = new EventEmitter<any>();
  @Output() deletePolygonForPointPolygon = new EventEmitter<any>();
  @Output() isStepCompletedEmit = new EventEmitter<any>();
  @Input() PointToPolygon
  @Input() uploadRaster
  @Input() DataCollectionPolygon
  @Input() moduleType

  @Input() moduleName: string;
  // mapid is used only in analysis
  @Input() mapid;
  //uploadfiletype is used for making sure if excel and csv can type is on
  @Input() uploadFileType: string = "";

  @Input() layerType: any;
  // @Output() changeStepperIndex = new EventEmitter<any>();
  @Output() onUploadDone = new EventEmitter<any>(); 
  @Output() loginStatus = new EventEmitter<any>();
  uploadThisFile: boolean = true;
  // files: any[];
  isVisible: boolean;
  file: File;
  files: File[] = [];
  buttonLoader: boolean = false;
  // @Input() onResetFromParent;
  @Input() TerritoryPointRefernce = false
  @Input() TerritoryInsertType

  accept;
  @Input() existingLayerId

  color = 'warn';
  mode = 'determinate';
  progressValue = 0;
  bufferValue = 0;
  filesToConvert = [];
  isLoggedIn: boolean;
  multiple

  ngAfterViewInit() {
    this.progressValue = 0;

    // console.log(this.uploadFileType);
    // console.log(this.moduleName);

  }

  @Input() authenticationService:any;
  constructor(private _appAnalysis: AppAnalysisService, 
    private uploadFilesService: UploadFilesService,
    // private authenticationService: AuthService, 
    private MatDialog: MatDialog, 
    private snackBar: MatSnackBar, 
    private _router: Router
  ) {
    // this.authCheck()
  }


  // authCheck() {
  //   this.authenticationService.isLoggedIn.subscribe((data) => {
  //     this.isLoggedIn = this.authenticationService.isAuthenticated();
  //   })
  // }

  ngOnInit() {
    this.uploadFilesService.getName.subscribe(response => {
      // console.log("this is response == ", response)
      this.progressValue = response;
    });
    this.multiple = false

    if (this.uploadFileType == "EXCEL_CSV") {
      this.accept = '.csv, .xlsx, .xls, .ods'
      this.multiple = false
    }
    else if (this.uploadFileType == "VECTOR") {
      this.accept = ' .kml, .gml, .geojson,.shp, .shx, .dbf, .prj, .dxf, .mif , .tab , .kmz , .gpkg, .sqlite, .zip, .map, .dat, .gps, .topojson, .id, .gpx, .sbf, .pdf'
      this.multiple = true

    }

    if (this.uploadFileType == "RASTER") {
      this.accept = '.tif, .tiff, .geotiff'
      this.multiple = true
    }


    else if (this.moduleName == "CONVERTER") {
      this.accept = ".kml, .gml, .geojson, .shp, .shx, .dbf, .prj, .sbf, .dxf, .mif, .tab, .kmz, .gpkg, .tif, .sqlite, .csv, .xls, .xlsx, .zip, .map, .dat,.gps, .topojson, .id, .gpx, .pdf, .ods"
      this.multiple = true
    }


  }



  ngOnChanges() {
    // if(this.onResetFromParent === "true"){
    //   this.OnReset()
    // }
    // console.log('-------layer Type --->',this.layerType);
    // if(this.uploadFileType=='Excel_Csv'){
    //   this.accept ='.csv, .xls, .xlsx';
    // }
    // else if(this.layerType=='RASTER'){
    //   this.accept = '.tif,.tiff,.geotiff'
    //   this.uploadFileType = 'raster'
    // }
    // else if (this.layerType=='VECTOR'){
    //   this.uploadFileType = 'vector'
    //   this.accept ='.kml, .gml, .geojson, .shp, .shx, .dbf, .prj, .sbf, .dxf, .mif, .tab, .kmz, .gpkg, .sqlite,.zip, .map, .dat,.gps, .topojson,';
    // }
  }

  ngAfterContentInit(): void {
    //Called after ngOnInit when the component's or directive's content has been initialized.
    //Add 'implements AfterContentInit' to the class.

  }



  fileName;
  fileList;
  fileUpload(event: any) {
    if(!this.multiple){
      this.files = [];
      if(event.length != 1){
      this.uploadFilesService.openSnackBar("Please upload 1 file at time", "snackbar-error", "fail")
      return
      }
    }
    // this.onResetFromParent = "";  
    this.files = [];
    // console.log(event);
    let fileList: FileList = event;
    let arr1 = []
    for (let i = 0; i < fileList.length; i++) {
      let ext = fileList[i].name.split(".")[1]
      arr1.push(ext)
    }
    this.fileList = fileList;
    this.uploadThisFile = true //  missing shp file will set uploadfile to false , user will not be able to upload another type of file hence turn true


    if (arr1.includes('shp') || arr1.includes('prj')
      || arr1.includes('shx') || arr1.includes('dbf')) {
      if (arr1.includes('shp') && arr1.includes('prj')
        && arr1.includes('shx') && arr1.includes('dbf')) {
        // console.log("All files recived for shp");
        this.uploadThisFile = true;
        // this.uploadFileType = "vector"
        this.fileName = this.fileList[0].name.split(".")[0];
        // console.log(this.fileList);
      }
      else {
        this.uploadThisFile = false;
        arr1 = []
        this.uploadFilesService.openSnackBar("Please upload all files related to .shp", "snackbar-error", "fail")

      }
    }
    if (this.uploadThisFile === true) {

      this.fileName = this.fileList[0].name.split(".")[0];
      if (arr1.includes('tif') || arr1.includes('tiff') || arr1.includes('geotiff')) {
        this.uploadFileType = "raster"
      }
      else if (arr1.includes('csv') || arr1.includes('xls') || arr1.includes('xlsx') ||
        arr1.includes('ods')) {
        this.uploadFileType = 'Excel_Csv'
      }
      else {
        if (this.uploadFileType == "VECTOR") {
          this.uploadFileType = "vector";
        }
      }
    }
  }

  uploadFile() {
    this.buttonLoader = true;

    // this._appAnalysis.uploadRasterFile(this.mapid,this.fileName).subscribe(data=>{
    //   console.log(data)
    // })
    if (this.isStoreMapper) {
      this.moduleName = "STOREMAPPER"
    }
    this.uploadFilesService.uploadFiles(this.fileList, this.moduleName, this.mapid, this.uploadFileType)
      .subscribe(
        data => {
          // Go to mat stepper next step in Excel/Csv and Vector Files upload module

          this.buttonLoader = false;
          // console.log('success data of file', data)
          // The below code might be helpful for 
          // if(data["body"].http_code==200){
          if (data.body["data"]) {
            this.nextStepper.emit('')
            this.filesToConvert = data.body["data"];
            // this.openSnackBar("File Uploaded Succesfully","snackbar-success","success");
            //Check code
            if (this.PointToPolygon) {
              if (this.filesToConvert[0].layer_type == 'POINT') {
                this.onUploadDone.emit({ filesToConvert: this.filesToConvert, mapId: this.mapid });
                this.isStepCompletedEmit.emit()
                this.OnReset();
                if (this.uploadFileType == "vector") {
                  this.uploadFilesService.openSnackBar("File Uploaded Succesfully", "snackbar-success", "success");
                  this.isStepCompletedEmit.emit()
                  // this.isNewMapCreated ?  this._router.navigateByUrl(`/upload-vector-files/${this.mapid}/done`) :  this._router.navigateByUrl("/upload-vector-files/"+this.mapid)
                  // this._router.navigateByUrl(`/upload-vector-files/${this.mapid}/done`)
                  if (!this.PointToPolygon) {
                    this._router.navigateByUrl(`/map-analysis/upload-vector-files/${this.mapid}/${this.filesToConvert[0].layer_id}`)
                  }
                  else {
                    this._router.navigateByUrl(`/map-analysis/point-to-polygon/${this.mapid}/${this.filesToConvert[0].layer_id}`)
                  }
                  this.emitData.emit(data)
                  // redirect to next step in stepper
                  // this.changeStepperIndex.emit('')

                }
              }
              else {
                this.uploadFilesService.openSnackBar("Please upload Point file", "snackbar-error", "fail");
                this.OnReset();
                this.deletePolygonForPointPolygon.emit(this.filesToConvert[0].layer_id)
              }
            }
            else if(this.DataCollectionPolygon) {
              if (this.filesToConvert[0].layer_type == 'POLYGON') {
                this.onUploadDone.emit({ filesToConvert: this.filesToConvert, mapId: this.mapid });
                this.isStepCompletedEmit.emit()
                this.OnReset();
                if (this.uploadFileType == "vector") {
                  this.uploadFilesService.openSnackBar("File Uploaded Succesfully", "snackbar-success", "success");
                  this.isStepCompletedEmit.emit()
                  this._router.navigateByUrl(`/data-collection/${this.mapid}`)
                  this.emitData.emit(data)
                  // redirect to next step in stepper
                  // this.changeStepperIndex.emit('')

                }
              }
              else {
                this.uploadFilesService.openSnackBar("Please upload Polygon file", "snackbar-error", "fail");
                this.OnReset();
                this.deletePolygonForPointPolygon.emit(this.filesToConvert[0].layer_id)
              }
            }

            else if (this.splitPoly || this.mergePoly) {
              if (this.filesToConvert[0].layer_type == 'POLYGON') {
                this.onUploadDone.emit({ filesToConvert: this.filesToConvert, mapId: this.mapid });
                // this.isStepCompletedEmit.emit()
                this.OnReset();
                if (this.uploadFileType == "vector") {
                  this.uploadFilesService.openSnackBar("File Uploaded Succesfully", "snackbar-success", "success");
                  this.isStepCompletedEmit.emit()
                  // this.isNewMapCreated ?  this._router.navigateByUrl(`/upload-vector-files/${this.mapid}/done`) :  this._router.navigateByUrl("/upload-vector-files/"+this.mapid)
                  if (this.splitPoly) {
                    this._router.navigateByUrl(`/map-analysis/split-polygon/${this.mapid}/${this.filesToConvert[0].layer_id}`)
                  } else if (this.mergePoly) {
                    this._router.navigateByUrl(`/map-analysis/merge-polygon/${this.mapid}/${this.filesToConvert[0].layer_id}`)
                  }
                  else if (this.PointToPolygon) {
                    this._router.navigateByUrl(`/map-analysis/point-to-polygon/${this.mapid}/${this.filesToConvert[0].layer_id}`)
                  }
                  else {
                    this._router.navigateByUrl(`/map-analysis/upload-vector-files/${this.mapid}/${this.filesToConvert[0].layer_id}`)
                  }
                  this.emitData.emit(data)
                  // redirect to next step in stepper
                  // this.changeStepperIndex.emit('')

                }
              }
              else {
                this.uploadFilesService.openSnackBar("Please upload Polygon file", "snackbar-error", "fail");
                this.OnReset();
                this.deletePointForSplitPolygon.emit(this.filesToConvert[0].layer_id)
              }
            }

            else if (this.moduleName === "TerritoryModule") {

              if (this.filesToConvert[0].layer_type != 'POLYGON') {
                this.uploadFilesService.openSnackBar("Please Upload a Polygon Data File", "snackbar-error", "fail")
                return
              }
              this._router.navigate(['data-collection', this.mapid])
              this.onUploadDone.emit({ filesToConvert: this.filesToConvert, mapId: this.mapid });

            }
            else if (this.moduleName === "TerritoryModulePoint") {

              if (!this.filesToConvert) {
                this.uploadFilesService.openSnackBar("Please Upload a Point Data File", "snackbar-error", "fail")
                return
              }
              this.onUploadDone.emit({ filesToConvert: this.filesToConvert, mapId: this.mapid });

            }


            else {
              this.onUploadDone.emit({ filesToConvert: this.filesToConvert, mapId: this.mapid });
              this.isStepCompletedEmit.emit()
              this.OnReset();
              if (this.uploadFileType == "vector") {
                this.uploadFilesService.openSnackBar("Your vector data is uploaded successfully", "snackbar-success", "success");
                this.isStepCompletedEmit.emit()
                // this.isNewMapCreated ?  this._router.navigateByUrl(`/upload-vector-files/${this.mapid}/done`) :  this._router.navigateByUrl("/upload-vector-files/"+this.mapid)
                if (this.splitPoly) {
                  this._router.navigateByUrl(`/map-analysis/split-polygon/${this.mapid}`)
                } else if (this.mergePoly) {
                  this._router.navigateByUrl(`/map-analysis/merge-polygon/${this.mapid}/done`)
                }
                else if (this.PointToPolygon) {
                  this._router.navigateByUrl(`/map-analysis/point-to-polygon/${this.mapid}/done`)
                }
                else {
                  this._router.navigateByUrl(`/map-analysis/upload-vector-files/${this.mapid}/done`)
                }
                this.emitData.emit(data)
                // redirect to next step in stepper
                // this.changeStepperIndex.emit('')

              }
              else if (this.moduleName == 'upload-raster') {
                this.uploadFilesService.openSnackBar("Your raster data is uploaded successfully", "snackbar-success", "success");
                // this.isStepCompletedEmit.emit()
                this._router.navigateByUrl(`/map-analysis/upload-raster/${this.mapid}/done`)
                this.emitData.emit(data)

              }
            }

          }
          else {
            this.uploadFilesService.openSnackBar("Your file couldn't be proccessed , please check the documentation guide and try again", "snackbar-error", "fail");
            this.buttonLoader = false;

          }
          // this.uploadFilesService.stepTwoEnabled.next(this.filesToConvert);
          // }
          this.progressValue = 0;
          this.files = [];
          this.isVisible = false;
        },
        error => {
          this.uploadFilesService.openSnackBar("Your file couldn't be proccessed , please check the documentation guide and try again", "snackbar-error", "fail")
          // console.log(error);
          this.progressValue = 0;
          this.files = [];
          this.buttonLoader = false;

        }
      );
  }

  onSubmit() {

    if (this.isLoggedIn == false) {
      // const dialogRef = this.MatDialog.open(LoginSignupModalComponent, {
      //   width: '75%',
      //   data: { loginModel: true, ModuleName: 'UPLOAD' }
      // });
      // dialogRef.afterClosed().subscribe(data => {
      //     this.isLoggedIn = this.authenticationService.isAuthenticated();
      //     this.loginStatus.emit( this.isLoggedIn)
      //     // this.planfn()
      // })
      return
    }
    else {

      if(this.moduleType === "POI"){
        this.uploadFile();
        return
      }
  

      if (this.mapid) {
        if (this.moduleName === "TerritoryModule" || this.moduleName === "TerritoryPointToPolygon") {
          if (this.TerritoryPointRefernce) {
            this.UploadTerritoryPointRefernce()
            return
          }
          this.UploadTerritoryModuleFile()
        }else if (this.isStoreMapper) {
          this.isNewMapCreated = true;
          this._appAnalysis.createNewMap("", "Untitled Map (Store Mapper)", "", "store-mapper", "").subscribe(data => {
            this.mapid = data.data.mapid
            this.uploadFile()
          })

        } 
        else {
          this.uploadFile()
        }
        

      }
      else {
        if (this.moduleName == 'CONVERTER') {
          this.isNewMapCreated = true;
          //Ritivesh Commented To stop creating map in converter
          // this.uploadFile()
          this._appAnalysis.createNewMap("", "Untitled Map (Converter)", "", "", "").subscribe(data => {
            this.mapid = data.data.mapid
            this.uploadFile()
          })
        }
        else if (this.uploadFileType == 'Excel_Csv') {

          if (this.Geocoder) {
            this.isNewMapCreated = true;
            this._appAnalysis.createNewMap("", "Untitled Map (Geocoder)", "", "gis-analysis", "").subscribe(data => {
              this.mapid = data.data.mapid
              this.uploadFile()
            })
          } else if (this.isStoreMapper) {
            this.isNewMapCreated = true;
            this._appAnalysis.createNewMap("", "Untitled Map (Store Mapper)", "", "store-mapper", "").subscribe(data => {
              this.mapid = data.data.mapid
              this.uploadFile()
            })

          }
          else if (this.moduleName === "TerritoryModulePoint") {
            this.isNewMapCreated = true;
            this._appAnalysis.createNewMap("", "Untitled Map (Create Territory Data)", "", "territory-design", "").subscribe(data => {
              this.mapid = data.data.mapid
              this.uploadFile()
            })
          }
          else {
            this.isNewMapCreated = true;
            this._appAnalysis.createNewMap("", "Untitled Map (Added Excel/CSV)", "", "gis-analysis", "").subscribe(data => {
              this.mapid = data.data.mapid
              this.uploadFile()
            })
          }
        }
        else if (this.uploadFileType == 'vector' || this.uploadFileType == 'point_to_polygon') {

          if (this.splitPoly) {
            this.isNewMapCreated = true;
            this._appAnalysis.createNewMap("", "Untitled Map (Split Polygon)", "", "gis-analysis", "").subscribe(data => {
              this.mapid = data.data.mapid
              this.uploadFile()
            })
          }
          else if (this.mergePoly) {
            this.isNewMapCreated = true;
            this._appAnalysis.createNewMap("", "Untitled Map (Merge Polygon)", "", "gis-analysis", "").subscribe(data => {
              this.mapid = data.data.mapid
              this.uploadFile()
            })
          }

          else if (this.PointToPolygon) {
            this.isNewMapCreated = true;
            this._appAnalysis.createNewMap("", "Untitled Map (Point To Polygon)", "", "gis-analysis", "").subscribe(data => {
              this.mapid = data.data.mapid
              this.uploadFile()
            })
          }
          else if (this.moduleName === "TerritoryModule") {
            this.isNewMapCreated = true;
            this._appAnalysis.createNewMap("", "Untitled Map (Create Territory Data)", "", "territory-design", "").subscribe(data => {
              this.mapid = data.data.mapid
              this.UploadTerritoryModuleFile()
            })
          }

          else {
            this.isNewMapCreated = true;
            this._appAnalysis.createNewMap("", "Untitled Map (Added Vector)", "", "gis-analysis", "").subscribe(data => {
              this.mapid = data.data.mapid
              this.uploadFile()
            })
          }
        }
        else if (this.uploadRaster) {

          this.isNewMapCreated = true;
          this._appAnalysis.createNewMap("", "Untitled Map (RASTER)", "", "gis-analysis", "").subscribe(data => {
            this.mapid = data.data.mapid
            this.uploadFile()
          })

        }
        else {
          this.isNewMapCreated = true;
          this._appAnalysis.createNewMap("", "Untitled Map", "", "gis-analysis", "").subscribe(data => {
            this.mapid = data.data.mapid
            this.uploadFile()
          })
        }
      }
    }


  }

  //Upload File from Territory-Module
  UploadTerritoryModuleFile() {
    this.buttonLoader = true;
    let layerid = this.existingLayerId ? this.existingLayerId : "";
    this.uploadFilesService.UploadTerritoryFiles(this.fileList, this.moduleName, this.mapid, layerid, this.uploadFileType, this.TerritoryInsertType).subscribe(
      (result) => {
        this.buttonLoader = false;
        if (result.status === 200) {

          if (result.body.http_code == 200) {
            this._router.navigate(["data-collection", this.mapid], { queryParams: { show: "ok" } })
            this.emitData.emit(result)
            this.OnReset();
            this.uploadFilesService.name.next(0)
          }
          else if (result.body.http_code === 400) {
            this.uploadFilesService.openSnackBar(result.body.data, "snackbar-error", "fail")
            this.OnReset();
            this.uploadFilesService.name.next(0)
            // this._appAnalysis.deleteMap(this.mapid).subscribe(data=>{
            // })
          }

        } else {
          this.buttonLoader = false;
          this.OnReset();
          this.uploadFilesService.name.next(0)
        }


      }, (err) => {
        this.buttonLoader = false;

      })
  }

  OnReset() {
    this.fileName = "";
    this.files = [];
    this.uploadThisFile = false;
  }

  CheckData() { return this.fileName ? false : true; }

  UploadTerritoryPointRefernce() {
    this.buttonLoader = true;
    this.uploadFilesService.uploadFiles(this.fileList, this.moduleName, this.mapid, this.uploadFileType, this.TerritoryPointRefernce)
      .subscribe(data => {
        this.buttonLoader = false

        this.filesToConvert = data.body["data"];

        if (!this.filesToConvert) {
          this.uploadFilesService.openSnackBar("Please Upload a Point Data File", "snackbar-error", "fail")
          return
        }

        if(this.uploadFileType === "VECTOR" || this.uploadFileType === "vector" ){
          if (this.filesToConvert[0].layer_type == 'POINT') {

            this.onUploadDone.emit({ filesToConvert: this.filesToConvert, mapId: this.mapid });
            this.isStepCompletedEmit.emit()
            this.OnReset();
            this.uploadFilesService.name.next(0)
          }
  
          else if (this.filesToConvert[0].layer_type == 'POLYGON' || this.filesToConvert[0].layer_type == "POLYLINE" ) {
            this.uploadFilesService.openSnackBar("Please upload Point file", "snackbar-error", "fail");
            this.OnReset();
            this.DeleteLayer(this.filesToConvert[0].layer_id)
          }
        }
        else if (this.uploadFileType === "EXCEL_CSV" || this.uploadFileType === "Excel_Csv"  ){

          this.onUploadDone.emit({ filesToConvert: this.filesToConvert, mapId: this.mapid });
          this.isStepCompletedEmit.emit()
          this.OnReset();
          this.uploadFilesService.name.next(0)
          this.emitData.emit(data)
          this.nextStepper.emit('')


          // this.onUploadDone.emit({ filesToConvert: this.filesToConvert, mapId: this.mapid });
          // this.isStepCompletedEmit.emit()
          // this.OnReset();

        }
        this.progressValue = 0


      }, (err) => {
        this.buttonLoader = false
        this.OnReset();
        this.uploadFilesService.name.next(0)
      })

  }

  DeleteLayer(layerid){
    this._appAnalysis.deleteLayer(layerid).subscribe(data => {
      // console.log(data)
    })

  }



}